import React, { Fragment } from "react";

import { chaptersPerDay } from "../messages";

import SmallInput from "components/Form/SmallInput";
import { FormFeedback } from ".";
import WeekDaysSelector from "components/WeekDaysSelector";
import ReadingInputs from "../components/ReadingInputs";
import { useNewChallenge } from "contexts/Challenge/NewChallenge";
import ReadingOrderSelector from "components/FormPlan/components/ReadingOrderSelector";

const ChaptersPerDay = () => {
  const {
    quantityOfChapters,
    setQuantityOfChapters,
    blockedWeekDays,
    setBlockedWeekDays,
    readingOrder,
    setReadingOrder,
  } = useNewChallenge();

  const onChange = ({ target: { value } }) =>
    setQuantityOfChapters(Number(value));

  return (
    <Fragment>
      <div className="chapters-per-day">
        <div className="form__row">
          <SmallInput
            type="number"
            defaultValue={quantityOfChapters}
            name="days"
            onChange={onChange}
            label={chaptersPerDay}
            max={1190}
          />
        </div>
        <WeekDaysSelector
          blockedWeekDays={blockedWeekDays}
          onChange={setBlockedWeekDays}
        />

        <ReadingOrderSelector
          readingOrder={readingOrder}
          setReadingOrder={setReadingOrder}
        />
        <ReadingInputs />

        <FormFeedback />
      </div>
    </Fragment>
  );
};

export default ChaptersPerDay;
